import { render, staticRenderFns } from "./DemoDone.vue?vue&type=template&id=6710534a"
import script from "./DemoDone.vue?vue&type=script&lang=js"
export * from "./DemoDone.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports